import React from "react";
import { BiHeart } from "react-icons/bi";
const OrderItemsCard = ({ image, name, description, quantity, price }) => {
  return (
    <div className="flex justify-between items-center max-w-[30vw] bg-slate-100 my-1 p-1 rounded relative min-w-[320px] mx-1">
      <div className="flex flex-1 items-center ">
        <img
          className="inline-block"
          src={`${image}`}
          height={50}
          width={50}
          alt="product image"
        />
        <div className=" text-sm mx-2 flex-1">
          <div className="flex flex-row md:justify-between items-center">
            <h1 className="text-slate-900 font-bold  line-clamp-1">{name}</h1>
            <div className=" flex  mt-2 md:mr-2  md:mt-0">
              <span className="border px-2 mx-1">{quantity}</span>
            </div>
          </div>
          <div className="">
            <div className="prizeAndButton font-bold text-[#FF7A00] text-lg ">
              ৳ {price * quantity} {/* Update this line */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsCard;
